<template>
  <div class="table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th
            v-for="column in table.columnNames"
            :key="column"
            class="list__column"
          >
            {{ column }}
          </th>
          <th v-if="mode !== 'formatting'" class="list__column">
            Операция
          </th>
          <th v-if="mode !== 'formatting'" class="list__column">
            Записываемое значение
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td class="list__row">
            <router-link :to="getRecordLink(item)" target="_blank">
              <i class="fa fa-link" />
            </router-link>
          </td>
          <td
            v-for="row in table.defaultRowNames"
            :key="row"
            class="list__row"
          >
           {{ getRow(item[row]) }}
          </td>
          <td class="list__row">
            {{ getEntityRow(item) }}
          </td>
          <td class="list__row">
            {{ item.previous_value }}
          </td>
          <td class="list__row">
            <Counter
              v-if="mode === 'formatting'"
              model-field="new_value"
              :item="item"
              :min="1"
            />
            <span v-else>
              {{ item.new_value }}
            </span>
          </td>
          <td v-if="mode !== 'formatting'" class="list__row">
            {{ getOperationName(item) }}
          </td>
          <td v-if="mode !== 'formatting'" class="list__row">
            {{ Math.abs(item.new_value - item.previous_value) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Counter from '@/_shared/components/ui/Counter';
import { useTableHelper } from '@/_shared/mixins';
import { stockMovement, lists } from '@/stock/constants';
import store from "@/stock/store";
export default {
  mixins: [useTableHelper],
  components: {
    Counter,
  },
  computed: {
    items() {
      return store.state.inventory.items;
    },
    mode() {
      return store.state.inventory.mode;
    },
    table() {
      return lists.inventory;
    },
  },
  methods: {
    getOperationName(item) {
      const names = {
        arrivals: 'приход',
        write_offs: 'списание',
        none: 'нет',
      };
      return names[item.operation_type];
    },
    getEntityRow(item) {
      const entities = stockMovement.entity.byForeignKey;
      const key = `${item.entity}_id`;
      return entities[key];
    },
    getRecordLink(item) {
      const key = `${item.entity}_id`;
      const table = stockMovement.tables[key];
      return `${table}/${item.id}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/components/inventory/ItemsTable.vue